import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import { toast } from 'react-toastify';

import Button from '../../common/Button';

import { showModal } from '../../../actions/modal';
import { fetchImportSubscriptionData } from '../../../actions/items';

import { getProductImageUrl, parseError } from '../../../helpers';

const Wrapper = styled('div')`
  .fixed-table-container {
    margin-top: 25px;

    .variant-id-span {
      font-size: 11px;
      color: #98a6ad;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }

    .variant-id-span {
      cursor: initial !important;
      text-decoration: initial !important;
    }
  }
`;

const SubscriptionBlock = (props) => {
  const { isNew, currentProduct, saveProduct } = props;

  const dispatch = useDispatch();
  const [subscriptionData, setSubscriptionData] = useState(null);

  useEffect(() => {
    if (subscriptionData === null) {
      if (currentProduct && currentProduct.subscriptionInfo) {
        setSubscriptionData(currentProduct.subscriptionInfo.items);
      }
    }
  }, [currentProduct]);

  const handleImportTemplate = () => {
    dispatch(
      showModal('ImportProductsFromExcel', {
        handleImport: async (file) => {
          let iteratingProduct = currentProduct;
          if (isNew) {
            await saveProduct().then((res) => {
              iteratingProduct = res;
            });
          }
          dispatch(
            fetchImportSubscriptionData({
              file,
              productId: iteratingProduct.id,
              variantId: iteratingProduct.variants[0].id,
            }),
          )
            .then((res) => {
              toast.info('Состав подписки успешно обновлен');
              setSubscriptionData(res.items);
            })
            .catch((err) => {
              toast.error(parseError(err));
            });
        },
        handleLoadImportTemplate: () => false,
        showTemplateButton: false,
        showSearchByField: false,
      }),
    );
  };

  return (
    <Wrapper className="card-box">
      <div className="row">
        <div className="col-12">
          <h4 className="header-title">Шаблон подписки</h4>
        </div>
      </div>

      <div className="row" style={{ alignItems: 'center' }}>
        <div className="col-3" style={{ marginTop: '26px' }}>
          <Button
            classType="btn-light"
            icon="fe-arrow-up"
            text="Загрузить шаблон"
            onClick={handleImportTemplate}
          />
        </div>
      </div>
      <div className="bootstrap-table">
        <div className="fixed-table-container">
          <div className="fixed-table-body">
            <table className="table table-centered">
              <thead className="thead-light">
                <tr>
                  <th />
                  <th>Наименование</th>
                  <th>Отравление</th>
                  <th>Цена</th>
                  <th>Количество</th>
                </tr>
              </thead>
              {subscriptionData ? (
                <tbody>
                  {subscriptionData.map((s) => (
                    <tr key={`${s.productId}-${s.variantId}`}>
                      <td>
                        <div
                          className="image-block"
                          style={{ backgroundImage: `url(${getProductImageUrl(s, 100)})` }}
                        />
                      </td>
                      <td>
                        {s.shortName}
                        <span className="variant-id-span">
                          {s.variantId}
                          {s.extId ? `(${s.extId})` : null}
                        </span>
                      </td>
                      <td>
                        <span className="badge" style={{ backgroundColor: 'black' }}>
                          {s.subscriptionShipmentNum}
                        </span>
                      </td>
                      <td>{s.itemPrice}</td>
                      <td>{s.count}</td>
                    </tr>
                  ))}
                </tbody>
              ) : null}
            </table>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default SubscriptionBlock;
